import React, { useState, useEffect } from 'react';
// import CarServices from '../../services/CarServices';
import MembershipServiceListServices from '../../services/MembershipServiceListServices';
import { useNavigate } from 'react-router-dom';
import PostListService from '../../services/PostListServices';

function PostUpdate({ service, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    serviced: '',
    caption: '',
    images: [],
  });
   const navigate = useNavigate();
  const [previewImages, setPreviewImages] = useState([]);
    const [existingImages, setExistingImages] = useState([]);
  const [uploadingImages, setUploadingImages] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const BASE_URL = process.env.REACT_APP_URL;

  // Load vendors
  // useEffect(() => {
  //   CarServices.getVendorActive().then(res => {
  //     if (res.status) setVendors(res.data);
  //   });
  // }, []);

useEffect(() => {
  const fetchServices = async () => {
    try {
      const res = await MembershipServiceListServices.getServiceGuest();

      if (res?.status) {
        const formatted = res.data
          .filter(item => item.title)
          .map(item => ({
            _id: item._id,
            title: item.title
          }));

        setVendors(formatted); // reuse same state
      }
    } catch (err) {
      console.error(err);
    }
  };

  fetchServices();
}, []);
  // Load service data
  // useEffect(() => {
  //   if (service) {
  //     setFormValues({
  //       serviced: service?.serviceId?.vendorId?._id || service?.serviceId?.vendorId || '',
  //       caption: service?.caption || '',
  //       images: [],
  //     });

  //     // Existing images preview
  //     if (service.images && service.images.length > 0) {
  //       const imageUrls = service.images.map(img =>
  //         img.startsWith('http') ? img : `${BASE_URL}${img}`
  //       );
  //       setPreviewImages(imageUrls);
  //     }
  //   }
  // }, [service, BASE_URL]);
useEffect(() => {
  if (service) {
    const imgs = service?.images || [];

    setFormValues({
      serviced: service?.serviceId?._id || '',
      caption: service?.caption || '',
      images: []
    });

    setExistingImages(imgs);

    const previews = imgs.map(img => ({
      type: "existing",
      url: img
    }));

    setPreviewImages(previews);
  }
}, [service]);
  // Handle text inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues(prev => ({ ...prev, [name]: value }));
  };

  // Handle file selection
  // const handleFileChange = (e) => {
  //   const files = Array.from(e.target.files);

  //   setFormValues(prev => ({
  //     ...prev,
  //     images: [...prev.images, ...files]
  //   }));

  //   // Create preview URLs for new files
  //   const newPreviews = files.map(f => URL.createObjectURL(f));
  //   setPreviewImages(prev => [...prev, ...newPreviews]);
  // };
  const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;
 
        setFormValues(prev => ({
            ...prev,
            images: [...prev.images, ...files]
        }));
 
        const previews = files.map(file => ({
            type: "new",
            url: URL.createObjectURL(file),
            file
        }));
        setPreviewImages(prev => [...prev, ...previews]);
    };
  // Remove image
  // const handleRemoveImage = async (imageToRemove, index) => {
  //   try {
  //     // Check if it's an existing image (string URL) or new file
  //     const isExistingImage = typeof imageToRemove === 'string' &&
  //       (imageToRemove.startsWith('http') || imageToRemove.includes(BASE_URL));

  //     if (isExistingImage) {
  //       // Extract the relative path for existing images
  //       const imagePath = imageToRemove.replace(BASE_URL, '');
  //       const response = await CarServices.removeImage({ url: imagePath });
  //       if (!response.status) {
  //         alert('Failed to remove image from server');
  //         return;
  //       }
  //     }

  //     // Remove from preview
  //     setPreviewImages(prev => prev.filter((_, idx) => idx !== index));

  //     // Remove from formValues (only for new files)
  //     if (!isExistingImage) {
  //       setFormValues(prev => ({
  //         ...prev,
  //         images: prev.images.filter((_, idx) => idx !== index)
  //       }));
  //     }

  //   } catch (error) {
  //     console.error('Failed to remove image', error);
  //     alert('Failed to remove image');
  //   }
  // };
const handleRemoveImage = (imgObj, index) => {
  setPreviewImages(prev => prev.filter((_, i) => i !== index));

  if (imgObj.type === "existing") {
    setExistingImages(prev => prev.filter(img => img !== imgObj.url));
  } else {
    setFormValues(prev => ({
      ...prev,
      images: prev.images.filter(file => file !== imgObj.file)
    }));
  }
};
  // Submit handler
  // Update the handleSubmit function in PostUpdate component
// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setLoading(true);
  
//   try {
//     // Only send new files, not existing image URLs
//     const newImageFiles = formValues.images.filter(img => img instanceof File);
    
//     const payload = {
//       serviced: formValues.serviced,
//       caption: formValues.caption,
//       images: newImageFiles
//     };

//     const response = await PostListService.updatePost(service._id, payload);
    
//     console.log("Response from API:", response);
//   if (response && response.data && response.data._id) {
//     alert(response.message || 'Post updated successfully ✅'); 
//     onSuccess(); 
//     closeModal(); 
//        navigate("/post-list");  
// } else {
//     alert('Failed to update ❌');
// }
    
//   } catch (error) {
//     console.error('Update error:', error);
//     alert(error?.message || error?.response?.data?.message || 'Error updating post ❌');
//   } finally {
//     setLoading(false);
//   }
// };



const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const formData = new FormData();

    formData.append("serviceId", formValues.serviced);
    formData.append("caption", formValues.caption);

    // existing images → convert to file
    for (let imgUrl of existingImages) {
      const response = await fetch(`${process.env.REACT_APP_URL}/${imgUrl}`);
      const blob = await response.blob();
      const filename = imgUrl.split('/').pop();

      formData.append("images", new File([blob], filename, { type: blob.type }));
    }

    // new images
    formValues.images.forEach(file => {
      formData.append("images", file);
    });

    const res = await PostListService.updatePost(service._id, formData);

    if (res.status) {
      alert(res.message);
      onSuccess();
      closeModal();
      navigate("/post-list");
    } else {
      alert(res.message || "Update failed ❌");
    }

  } catch (error) {
    console.error(error);
    alert(error.response?.data?.message || "Error ❌");
  } finally {
    setLoading(false);
  }
};
  return (
    <div className="modal fade edit-box show d-block" tabIndex={-1}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Post</h5>
            <button type="button" className="btn-close" onClick={closeModal} />
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Vendor Selection - maps to serviced */}
                <div className="col-lg-6 mb-3">
                  <label>Service Name *</label>
                  <select
                    name="serviced"
                    className="form-control"
                    value={formValues.serviced}
                    onChange={handleInputChange}
                    
                  >
                  <option value="">Select Service</option>
{vendors.map(v => (
  <option key={v._id} value={v._id}>
    {v.title}
  </option>
))}
                  </select>
                </div>

                {/* Caption - maps to caption */}
                <div className="col-lg-6 mb-3">
                  <label>Caption *</label>
                  <input
                    type="text"
                    name="caption"
                    className="form-control"
                    value={formValues.caption}
                    onChange={handleInputChange}
                    
                    placeholder="Enter caption"
                  />
                </div>

                {/* Images */}
           
                                <div className="col-lg-12 mt-3">
                                    <label>Images (Multiple)</label>
                                    <input
                                        type="file"
                                        multiple
                                        onChange={handleFileChange}
                                        className="form-control"
                                        accept="image/*"
                                    />
 
                                    {previewImages.length > 0 && (
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 10 }}>
                                            {previewImages.map((img, i) => (
                                                <div key={i} style={{ position: 'relative' }}>
                                                    <img
                                                        src={
                                                            img.type === "existing"
                                                                ? `${process.env.REACT_APP_URL}${img.url}`
                                                                : img.url
                                                        }
                                                        width="80"
                                                        height="80"
                                                        style={{ objectFit: 'cover', borderRadius: '4px' }}
                                                        alt=""
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveImage(img, i)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: -5,
                                                            right: -5,
                                                            background: 'red',
                                                            color: '#fff',
                                                            border: 'none',
                                                            borderRadius: '50%',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-success" disabled={loading}>
                  {loading ? 'Updating...' : 'UPDATE'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PostUpdate;